import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 bg-cream-alt" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-44">
            Además recibirás estos bonos sin costo adicional
          </h2>
          <p className="text-xl text-brown-light mb-6" data-id="element-45">
            Para ayudarte a aplicar las enseñanzas en tu vida diaria.
          </p>
          <div className="flex flex-col items-center gap-2" data-id="element-46">
            <span className="inline-block bg-gold-start/20 text-gold-end font-bold px-6 py-2 rounded-full text-lg" data-id="element-47">
              🎁 GRATIS por el día de hoy
            </span>
            <span className="text-brown-light text-base" data-id="element-48">
              Valor total:{' '}
              <span className="line-through opacity-60" data-id="element-49">$40.000</span> →{' '}
              <span className="text-gold-end font-bold" data-id="element-50">$0</span>
            </span>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-12" data-id="element-51">
          {/* BONO 1 */}
          <motion.div variants={itemVariants} className="bg-cream rounded-3xl overflow-hidden shadow-lg border border-gold-start/10 flex flex-col md:flex-row" data-id="element-52">
            <a href="https://claridadmental.shop/cart/53007812624747:1" className="md:w-2/5 block group overflow-hidden" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/nKChoAjmX71UagGXs16xH4/portada_bonus_1.jpg" alt="Bono 1: 7 Técnicas Efectivas" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-54" />
            </a>
            <div className="p-8 md:p-12 md:w-3/5 flex flex-col justify-center" data-id="element-55">
              <div className="flex items-center gap-3 mb-2" data-id="element-56">
                <span className="text-gold-end font-bold tracking-widest uppercase text-sm" data-id="element-57">
                  BONO #1
                </span>
                <span className="bg-red-500/10 text-red-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-58">
                  Valor: <span className="line-through" data-id="element-59">$20.000</span> → GRATIS
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-brown mb-4" data-id="element-60">
                7 Técnicas Efectivas para Encontrar la Paz Mental
              </h3>
              <p className="text-lg text-brown-light mb-6" data-id="element-61">
                Una guía práctica con técnicas diseñadas para ayudarte a:
              </p>
              <ul className="space-y-3" data-id="element-62">
                {['detener pensamientos repetitivos', 'recuperar claridad mental', 'volver al presente cuando tu mente se acelera', 'reducir el estrés mental rápidamente'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-63">
                    <span className="text-gold-end text-xl leading-none mt-0.5" data-id="element-64">
                      •
                    </span>
                    <span className="text-brown-light font-medium" data-id="element-65">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* BONO 2 */}
          <motion.div variants={itemVariants} className="bg-cream rounded-3xl overflow-hidden shadow-lg border border-gold-start/10 flex flex-col md:flex-row-reverse" data-id="element-66">
            <a href="https://claridadmental.shop/cart/53007812624747:1" className="md:w-2/5 block group overflow-hidden" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/kHvDsMohB9QLCQrtAHc6yt/portada_bonus.jpg" alt="Bono 2: Rutina de 5 Minutos" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-68" />
            </a>
            <div className="p-8 md:p-12 md:w-3/5 flex flex-col justify-center" data-id="element-69">
              <div className="flex items-center gap-3 mb-2" data-id="element-70">
                <span className="text-gold-end font-bold tracking-widest uppercase text-sm" data-id="element-71">
                  BONO #2
                </span>
                <span className="bg-red-500/10 text-red-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-72">
                  Valor: <span className="line-through" data-id="element-73">$20.000</span> → GRATIS
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-brown mb-4" data-id="element-74">
                Rutina de 5 Minutos para Empezar el Día con Calma
              </h3>
              <div className="space-y-4 text-lg text-brown-light font-medium" data-id="element-75">
                <p data-id="element-76">
                  Una rutina simple que podrás aplicar cada mañana para comenzar
                  el día con más tranquilidad, claridad y enfoque.
                </p>
                <p className="text-gold-end font-bold" data-id="element-77">
                  Solo necesitas 5 minutos al día.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}